import { isArray } from "@/utils/is";
import { FieldNamesProps } from "@/components/ProTable/interface";
import dayjs from "dayjs";

import { numberRide, formatValue as formatValue1 } from "@/utils/math";
/**
 * @description 校验身份证的真实性
 * @param {val} row 身份证号码
 * @returns {boolean}
 * */
export function checkIdCode(val) {
  const p = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
  const factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
  const parity = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2];
  const code = val.substring(17);
  if (p.test(val)) {
    let sum = 0;
    for (let i = 0; i < 17; i++) {
      sum += val[i] * factor[i];
    }
    if (parity[sum % 11] == code.toUpperCase()) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
}
export const changeTwoDecimal_f = (x: any) => {
  let f_x = parseFloat(x);
  if (isNaN(f_x)) {
    return null;
  }

  let fx = Math.round(formatValue1(numberRide(x, 100))) / 100;

  let s_x = fx.toString();
  let pos_decimal = s_x.indexOf(".");
  if (pos_decimal < 0) {
    pos_decimal = s_x.length;
    s_x += ".";
  }
  while (s_x.length <= pos_decimal + 2) {
    s_x += "0";
  }
  return s_x;
};
console.log(changeTwoDecimal_f(9353), "21321");
export function exportArrayToExcel({ key, data, title, filename, autoWidth }: any) {
  const wb = XLSX.utils.book_new();
  const arr = jsonToArray(key, data);
  arr.unshift(title);
  const ws = XLSX.utils.aoa_to_sheet(arr);
  if (autoWidth) {
    autoWidthFunc(ws, arr);
  }
  XLSX.utils.book_append_sheet(wb, ws, filename);
  XLSX.writeFile(wb, filename + ".xlsx");
}

/**
 * @description 处理 prop 为多级嵌套的情况，返回的数据 (列如: prop: user.name)
 * @param {Object} row 当前行数据
 * @param {String} prop 当前 prop
 * @returns {*}
 * */
export function handleToProp(row: { [key: string]: any }, prop: string) {
  if (!prop.includes(".")) {
    if (typeof row[prop] === "boolean") {
      return row[prop] ? "是" : "否";
    } else {
      return row[prop] ?? "";
    }
  }
  prop.split(".").forEach(item => (row = row[item] ?? ""));
  return row;
}
// 计算每个sku后面有多少项
export function getLevels(tree) {
  let level: any = [];
  for (let i = tree.length - 1; i >= 0; i--) {
    if (tree[i + 1] && tree[i + 1].specValueList) {
      level[i] = tree[i + 1].specValueList.length * level[i + 1] || 1;
    } else {
      level[i] = 1;
    }
  }
  return level;
}

/**
 * 笛卡尔积运算
 * @param  {[type]} tree   [description]
 * @param  {Array}  stocks [description]
 * @return {[type]}        [description]
 */
export function flatten1(tree: any, stocks: any[] = [], options: any) {
  let { optionValue = "id", optionText = "value" } = options || {};
  let result: any = [];
  let skuLen: any = 0;
  let stockMap: any = {}; // 记录已存在的stock的数据
  const level: any = getLevels(tree);
  if (tree.length === 0) return result;
  tree.forEach(sku => {
    const { specValueList: value } = sku;
    if (!value || value.length === 0) return true;
    skuLen = (skuLen || 1) * value.length;
  });
  // 根据已有的stocks生成一个map
  stocks.forEach((stock: any) => {
    let { specList, ...attr } = stock;
    stockMap[specList.map(item => `${item.keyId}_${item.valueId}`).join("|")] = attr;
  });

  for (let i = 0; i < skuLen; i++) {
    let specList: any = [];
    let mapKey: any = [];
    tree.forEach((sku, column: any) => {
      const { specValueList: value } = sku;
      let item = {};
      if (!value || value.length === 0) return true;
      if (value.length > 1) {
        // @ts-expect-error: TODO
        let row: any = parseInt(i / level[column], 10) % value.length;
        item = tree[column].specValueList[row];
      } else {
        item = tree[column].specValueList[0];
      }
      if (!sku[optionValue] || !item[optionValue]) return;
      mapKey.push(`${sku[optionValue]}_${item[optionValue]}`);
      specList.push({
        keyId: sku[optionValue],
        keyName: sku[optionText],
        valueId: item[optionValue],
        valueName: item[optionText]
      });
    });
    let { ...data } = stockMap[mapKey.join("|")] || {};
    // console.log(stockMap);
    // console.log(mapKey);
    // console.log(mapKey.join("|"));

    // 从map中找出存在的sku并保留其值
    result.push({
      costPrice: 0,
      listPrice: 0,
      publicPrice: 0,
      saleLimitPrice: 0,
      chiefPrice: 0,
      ceoPrice: 0,
      isOnline: "上架",
      price: 0,
      skuCode: "",
      specCode: "",
      stockNum: 0,
      updateStockNum: 0,
      realityStockNum: 0,
      remark: "",
      ...data,
      ids: specList.reduce((total, prev, index) => `${total}${prev.valueName}${index === specList.length - 1 ? "" : "｜"}`, ""),
      specList
    });
  }
  return result;
}
/**
 * 笛卡尔积运算
 * @param  {[type]} tree   [description]
 * @param  {Array}  stocks [description]
 * @return {[type]}        [description]
 */
export function flatten(tree: any, stocks: any[] = [], options: any) {
  let { optionValue = "id", optionText = "value" } = options || {};
  let result: any = [];
  let skuLen: any = 0;
  let stockMap: any = {}; // 记录已存在的stock的数据
  const level: any = getLevels(tree);
  if (tree.length === 0) return result;
  tree.forEach(sku => {
    const { specValueList: value } = sku;
    if (!value || value.length === 0) return true;
    skuLen = (skuLen || 1) * value.length;
  });
  // 根据已有的stocks生成一个map
  stocks.forEach((stock: any) => {
    let { specList, ...attr } = stock;
    stockMap[specList.map(item => `${item.keyId}_${item.valueId}`).join("|")] = attr;
  });

  for (let i = 0; i < skuLen; i++) {
    let specList: any = [];
    let mapKey: any = [];
    tree.forEach((sku, column: any) => {
      const { specValueList: value } = sku;
      let item = {};
      if (!value || value.length === 0) return true;
      if (value.length > 1) {
        // @ts-expect-error: TODO
        let row: any = parseInt(i / level[column], 10) % value.length;
        item = tree[column].specValueList[row];
      } else {
        item = tree[column].specValueList[0];
      }
      if (!sku[optionValue] || !item[optionValue]) return;
      mapKey.push(`${sku[optionValue]}_${item[optionValue]}`);
      specList.push({
        keyId: sku[optionValue],
        keyName: sku[optionText],
        valueId: item[optionValue],
        valueName: item[optionText]
      });
    });
    let { ...data } = stockMap[mapKey.join("|")] || {};
    // console.log(stockMap);
    // console.log(mapKey);
    // console.log(mapKey.join("|"));

    // 从map中找出存在的sku并保留其值
    result.push({
      costPrice: 0,
      // listPrice: 0,
      // publicPrice: 0,
      // saleLimitPrice: 0,
      // chiefPrice: 0,
      // ceoPrice: 0,
      isOnline: "上架",
      price: 0,
      skuCode: "",
      specCode: "",
      stockNum: 0,
      updateStockNum: 0,
      realityStockNum: 0,
      remark: "",
      ...data,
      ids: specList.reduce((total, prev, index) => `${total}${prev.valueName}${index === specList.length - 1 ? "" : "｜"}`, ""),
      specList
    });
  }
  return result;
}

/**
 * @description 判断是是否大于当前时间三十天
 * @param {any} targetTime 时间
 * @returns {any}
 */

export const isCurrentTimeGreaterThan = (targetTime: any) => {
  let currentTime = new Date();
  // 计算30天后的时间
  let thirtyDaysLater = new Date(targetTime);
  thirtyDaysLater.setDate(thirtyDaysLater.getDate() + 30);

  // 将日期对象转换为时间戳（单位：毫秒）
  let currentTimeStamp = currentTime.getTime();
  let thirtyDaysLaterTimeStamp = thirtyDaysLater.getTime();

  // 比较时间戳
  return currentTimeStamp > thirtyDaysLaterTimeStamp;
};
/**
 * @description 获取当月第一天
 * @param {any}
 * @returns {any}
 */
export function getFirstDayOfMonth() {
  const today = new Date();

  return dayjs(new Date(today.getFullYear(), today.getMonth(), 1)).format("YYYY-MM-DD");
}

/**
 * @description 获取当月最后一天
 * @param {any}
 * @returns {any}
 */
export function getLastDayOfMonth() {
  const today = new Date();
  const nextMonth = today.getMonth() + 1;
  const lastDay = new Date(today.getFullYear(), nextMonth, 0);
  return dayjs(lastDay).format("YYYY-MM-DD");
}

/**
 * @description 重定向到sso
 * @param {any} routeList 要处理的数组
 * @returns {any}
 */
export const redirectUrl = () => {
  let domain = window.location.href;
  const url = `${import.meta.env.VITE_APP_CORRRLATION_IMAGE_URL}login?redirectUrl=${domain}`;
  window.location.replace(url);
};
/**
 * @description 处理后端返回菜单数据
 * @param {Array} routeList 要处理的数组
 * @returns {Array}
 */
export function transformationAsyncRoutefn(routeList: any) {
  let arr = [] as Array<any>;
  const fn = (routeList: Array<any>, arr: Array<any>) => {
    routeList.forEach((route, index) => {
      // 嵌套一层
      let obj: any = {
        path: route.path,
        name: route.name,
        // hidden: route?.hidden ? true : false,
        component: route.component,
        redirect: route.redirect,
        meta: {
          title: route.title,
          icon: route.icon,
          isLink: "",
          isHide: route?.hidden,
          isFull: false,
          isAffix: route.isFixed,
          isKeepAlive: route.isCached
        },
        children: []
      };
      if (route.children.length === 0) {
        delete obj.children;
      }
      arr.push(obj);
      if (route.children) {
        fn(route.children, arr[index].children);
      }
    });
  };
  fn(routeList, arr);
  return arr;
}

/**
 * @description 获取localStorage
 * @param {String} key Storage名称
 * @returns {String}
 */
export function localGet(key: string) {
  const value = window.localStorage.getItem(key);
  try {
    return JSON.parse(window.localStorage.getItem(key) as string);
  } catch (error) {
    return value;
  }
}

/**
 * @description 存储localStorage
 * @param {String} key Storage名称
 * @param {*} value Storage值
 * @returns {void}
 */
export function localSet(key: string, value: any) {
  window.localStorage.setItem(key, JSON.stringify(value));
}

/**
 * @description 清除localStorage
 * @param {String} key Storage名称
 * @returns {void}
 */
export function localRemove(key: string) {
  window.localStorage.removeItem(key);
}

/**
 * @description 清除所有localStorage
 * @returns {void}
 */
export function localClear() {
  window.localStorage.clear();
}

/**
 * @description 判断数据类型
 * @param {*} val 需要判断类型的数据
 * @returns {String}
 */
export function isType(val: any) {
  if (val === null) return "null";
  if (typeof val !== "object") return typeof val;
  else return Object.prototype.toString.call(val).slice(8, -1).toLocaleLowerCase();
}

/**
 * @description 生成唯一 uuid
 * @returns {String}
 */
export function generateUUID() {
  let uuid = "";
  for (let i = 0; i < 32; i++) {
    let random = (Math.random() * 16) | 0;
    if (i === 8 || i === 12 || i === 16 || i === 20) uuid += "-";
    uuid += (i === 12 ? 4 : i === 16 ? (random & 3) | 8 : random).toString(16);
  }
  return uuid;
}

/**
 * 判断两个对象是否相同
 * @param {Object} a 要比较的对象一
 * @param {Object} b 要比较的对象二
 * @returns {Boolean} 相同返回 true，反之 false
 */
export function isObjectValueEqual(a: { [key: string]: any }, b: { [key: string]: any }) {
  if (!a || !b) return false;
  let aProps = Object.getOwnPropertyNames(a);
  let bProps = Object.getOwnPropertyNames(b);
  if (aProps.length != bProps.length) return false;
  for (let i = 0; i < aProps.length; i++) {
    let propName = aProps[i];
    let propA = a[propName];
    let propB = b[propName];
    if (!b.hasOwnProperty(propName)) return false;
    if (propA instanceof Object) {
      if (!isObjectValueEqual(propA, propB)) return false;
    } else if (propA !== propB) {
      return false;
    }
  }
  return true;
}

/**
 * @description 生成随机数
 * @param {Number} min 最小值
 * @param {Number} max 最大值
 * @returns {Number}
 */
export function randomNum(min: number, max: number): number {
  let num = Math.floor(Math.random() * (min - max) + max);
  return num;
}

/**
 * @description 获取当前时间对应的提示语
 * @returns {String}
 */
export function getTimeState() {
  let timeNow = new Date();
  let hours = timeNow.getHours();
  if (hours >= 6 && hours <= 10) return `早上好 ⛅`;
  if (hours >= 10 && hours <= 14) return `中午好 🌞`;
  if (hours >= 14 && hours <= 18) return `下午好 🌞`;
  if (hours >= 18 && hours <= 24) return `晚上好 🌛`;
  if (hours >= 0 && hours <= 6) return `凌晨好 🌛`;
}

/**
 * @description 获取浏览器默认语言
 * @returns {String}
 */
export function getBrowserLang() {
  let browserLang = navigator.language ? navigator.language : navigator.browserLanguage;
  let defaultBrowserLang = "";
  if (["cn", "zh", "zh-cn"].includes(browserLang.toLowerCase())) {
    defaultBrowserLang = "zh";
  } else {
    defaultBrowserLang = "en";
  }
  return defaultBrowserLang;
}

/**
 * @description 使用递归扁平化菜单，方便添加动态路由
 * @param {Array} menuList 菜单列表
 * @returns {Array}
 */
export function getFlatMenuList(menuList: Menu.MenuOptions[]): Menu.MenuOptions[] {
  let newMenuList: Menu.MenuOptions[] = JSON.parse(JSON.stringify(menuList));

  return newMenuList.flatMap(item => [item, ...(item.children ? getFlatMenuList(item.children) : [])]);
}

/**
 * @description 使用递归过滤出需要渲染在左侧菜单的列表 (需剔除 isHide == true 的菜单)
 * @param {Array} menuList 菜单列表
 * @returns {Array}
 * */
export function getShowMenuList(menuList: Menu.MenuOptions[]) {
  let newMenuList: Menu.MenuOptions[] = JSON.parse(JSON.stringify(menuList));
  return newMenuList.filter(item => {
    item.children?.length && (item.children = getShowMenuList(item.children));
    return !item.meta?.isHide;
  });
}

/**
 * @description 使用递归找出所有面包屑存储到 pinia/vuex 中
 * @param {Array} menuList 菜单列表
 * @param {Array} parent 父级菜单
 * @param {Object} result 处理后的结果
 * @returns {Object}
 */
export const getAllBreadcrumbList = (menuList: Menu.MenuOptions[], parent = [], result: { [key: string]: any } = {}) => {
  for (const item of menuList) {
    result[item.path] = [...parent, item];
    if (item.children) getAllBreadcrumbList(item.children, result[item.path], result);
  }
  return result;
};

/**
 * @description 使用递归处理路由菜单 path，生成一维数组 (第一版本地路由鉴权会用到，该函数暂未使用)
 * @param {Array} menuList 所有菜单列表
 * @param {Array} menuPathArr 菜单地址的一维数组 ['**','**']
 * @returns {Array}
 */
export function getMenuListPath(menuList: Menu.MenuOptions[], menuPathArr: string[] = []): string[] {
  for (const item of menuList) {
    if (typeof item === "object" && item.path) menuPathArr.push(item.path);
    if (item.children?.length) getMenuListPath(item.children, menuPathArr);
  }
  return menuPathArr;
}

/**
 * @description 递归查询当前 path 所对应的菜单对象 (该函数暂未使用)
 * @param {Array} menuList 菜单列表
 * @param {String} path 当前访问地址
 * @returns {Object | null}
 */
export function findMenuByPath(menuList: Menu.MenuOptions[], path: string): Menu.MenuOptions | null {
  for (const item of menuList) {
    if (item.path === path) return item;
    if (item.children) {
      const res = findMenuByPath(item.children, path);
      if (res) return res;
    }
  }
  return null;
}

/**
 * @description 使用递归过滤需要缓存的菜单 name (该函数暂未使用)
 * @param {Array} menuList 所有菜单列表
 * @param {Array} keepAliveNameArr 缓存的菜单 name ['**','**']
 * @returns {Array}
 * */
export function getKeepAliveRouterName(menuList: Menu.MenuOptions[], keepAliveNameArr: string[] = []) {
  menuList.forEach(item => {
    item.meta.isKeepAlive && item.name && keepAliveNameArr.push(item.name);
    item.children?.length && getKeepAliveRouterName(item.children, keepAliveNameArr);
  });
  return keepAliveNameArr;
}

/**
 * @description 格式化表格单元格默认值 (el-table-column)
 * @param {Number} row 行
 * @param {Number} col 列
 * @param {*} callValue 当前单元格值
 * @returns {String}
 * */
export function formatTableColumn(row: number, col: number, callValue: any) {
  // 如果当前值为数组，使用 / 拼接（根据需求自定义）
  if (isArray(callValue)) return callValue.length ? callValue.join(" / ") : "";
  return callValue ?? "";
}

/**
 * @description 处理值无数据情况
 * @param {*} callValue 需要处理的值
 * @returns {String}
 * */
export function formatValue(callValue: any) {
  // 如果当前值为数组，使用 / 拼接（根据需求自定义）
  if (isArray(callValue)) return callValue.length ? callValue.join(" / ") : "";
  return callValue ?? "";
}

/**
 * @description 处理 prop 为多级嵌套的情况，返回的数据 (列如: prop: user.name)
 * @param {Object} row 当前行数据
 * @param {String} prop 当前 prop
 * @returns {*}
 * */
export function handleRowAccordingToProp(row: { [key: string]: any }, prop: string) {
  if (!prop.includes(".")) return row[prop] ?? "";
  prop.split(".").forEach(item => (row = row[item] ?? ""));
  return row;
}

/**
 * @description 处理 prop，当 prop 为多级嵌套时 ==> 返回最后一级 prop
 * @param {String} prop 当前 prop
 * @returns {String}
 * */
export function handleProp(prop: string) {
  const propArr = prop.split(".");
  if (propArr.length == 1) return prop;
  return propArr[propArr.length - 1];
}

/**
 * @description 根据枚举列表查询当需要的数据（如果指定了 label 和 value 的 key值，会自动识别格式化）
 * @param {String} callValue 当前单元格值
 * @param {Array} enumData 字典列表
 * @param {Array} fieldNames label && value && children 的 key 值
 * @param {String} type 过滤类型（目前只有 tag）
 * @returns {String}
 * */
export function filterEnum(callValue: any, enumData?: any, fieldNames?: FieldNamesProps, type?: "tag") {
  const value = fieldNames?.value ?? "value";
  const label = fieldNames?.label ?? "label";
  const children = fieldNames?.children ?? "children";
  let filterData: { [key: string]: any } = {};
  // 判断 enumData 是否为数组
  if (Array.isArray(enumData)) filterData = findItemNested(enumData, callValue, value, children);
  // 判断是否输出的结果为 tag 类型
  if (type == "tag") {
    return filterData?.tagType ? filterData.tagType : "";
  } else {
    return filterData ? filterData[label] : "";
  }
}

/**
 * @description 递归查找 callValue 对应的 enum 值
 * */
export function findItemNested(enumData: any, callValue: any, value: string, children: string) {
  return enumData.reduce((accumulator: any, current: any) => {
    if (accumulator) return accumulator;
    if (current[value] === callValue) return current;
    if (current[children]) return findItemNested(current[children], callValue, value, children);
  }, null);
}
import * as XLSX from "xlsx";

function autoWidthFunc(ws, data) {
  // set worksheet max width per col
  const colWidth = data.map(row =>
    row.map(val => {
      let reg = new RegExp("[\\u4E00-\\u9FFF]+", "g"); //检测字符串是否包含汉字
      if (val == null) {
        return { wch: 10 };
      } else if (reg.test(val)) {
        return { wch: val.toString().length * 2 };
      } else {
        return { wch: val.toString().length };
      }
    })
  );
  // start in the first row
  const result = colWidth[0];
  for (let i = 1; i < colWidth.length; i++) {
    for (let j = 0; j < colWidth[i].length; j++) {
      if (result[j].wch < colWidth[i][j].wch) {
        result[j].wch = colWidth[i][j].wch;
      }
    }
  }
  ws["!cols"] = result;
}
function jsonToArray(key, jsonData) {
  return jsonData.map(v =>
    key.map(j => {
      return v[j];
    })
  );
}
